import { render, staticRenderFns } from "./SkillcourtAmsterdamLayout.vue?vue&type=template&id=761dd703&scoped=true&"
import script from "./SkillcourtAmsterdamLayout.vue?vue&type=script&lang=js&"
export * from "./SkillcourtAmsterdamLayout.vue?vue&type=script&lang=js&"
import style0 from "./SkillcourtAmsterdamLayout.vue?vue&type=style&index=0&id=761dd703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761dd703",
  null
  
)

export default component.exports